export const AI_DEEP_RESEARCH_RUN_STATUSES = [
    'queued',
    'running',
    'completed',
    'partially_completed',
    'failed',
    'cancelled',
];
export const AI_DEEP_RESEARCH_TERMINAL_STATUSES = [
    'completed',
    'partially_completed',
    'failed',
    'cancelled',
];
export const AI_DEEP_RESEARCH_ENTRY_POINTS = ['homepage', 'ask_ai'];
export const AI_DEEP_RESEARCH_TERMINAL_REASONS = [
    'user_cancellation',
    'permission_revoked',
    'tool_limit',
    'query_limit',
    'provider_error',
    'internal_error',
];
export const isAiDeepResearchRunTerminal = (status) => AI_DEEP_RESEARCH_TERMINAL_STATUSES.includes(status);
export const AI_DEEP_RESEARCH_HYPOTHESIS_VERDICTS = [
    'supported',
    'refuted',
    'inconclusive',
];
export const AI_DEEP_RESEARCH_EFFORTS = [
    'low',
    'medium',
    'high',
    'xhigh',
];
export const AI_DEEP_RESEARCH_CONFIDENCE_LEVELS = [
    'low',
    'medium',
    'high',
];
export const AI_DEEP_RESEARCH_EVENT_TYPES = [
    'status_changed',
    'cancellation_requested',
    'progress',
];
export const AI_DEEP_RESEARCH_PHASES = [
    'planning',
    'investigating',
    'validating',
    'synthesizing',
];
export const AI_DEEP_RESEARCH_ACTIVITIES = [
    'lightdash_metadata',
    'warehouse_query',
    'web_search',
    'web_fetch',
    'reporting',
];
//# sourceMappingURL=types.js.map